/* eslint-disable */

export const regex =
  /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i &&
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/ &&
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
